import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { UserDto } from '../../commonTypes/user.types';
import { useHttpPostSignOut } from '../../hooks';
import { RootState } from '../../store';
import { useMsal } from '@azure/msal-react';

interface ProfileMenuProps {
    setUserMenuVisible: (visible: boolean) => void;
}

const ProfileDropdown = ({ setUserMenuVisible }: ProfileMenuProps) => {
    const content = useSelector((state: RootState) => state.language.data);
    const user = useSelector<RootState, UserDto>(state => state.auth.value);
    const { instance } = useMsal();

    const { exec: signOut } = useHttpPostSignOut();
    const navigate = useNavigate();

    const navigateToProfile = () => {
        setUserMenuVisible(false);
        navigate(`/profile/${user.userSub}`);
    };

    const navigateToNotificationCenter = () => {
        setUserMenuVisible(false);
        navigate(`/notification-settings`);
    };

    const onLogout = () => {
        const account = instance.getActiveAccount() ?? instance.getAllAccounts()[0] ?? null;
        if (account) instance.setActiveAccount(null);
        signOut();
    };

    return (
        <div className="profile-dropdown">
            <div className="profile-dropdown__user-navigate" onClick={navigateToProfile}>
                <img src="/svg/settings.svg" alt="Profile Settings" />
                <p className="profile-dropdown__lbl">{content.profileMenu.profileSettings}</p>
            </div>

            <div className="profile-dropdown__user-navigate" onClick={navigateToNotificationCenter}>
                <img src="/svg/notification.svg" alt="Notification Center" />
                <p className="profile-dropdown__lbl">{content.profileMenu.notificationCenter}</p>
            </div>

            <hr />

            <div className="profile-dropdown__logout" onClick={onLogout}>
                <img src="/svg/logout.svg" alt="Logout" />
                <p className="profile-dropdown__lbl profile-dropdown__lbl--red">{content.profileMenu.logout}</p>
            </div>
        </div>
    );
};

export default ProfileDropdown;
